import { createSlice } from '@reduxjs/toolkit';

const sliceName = 'theme';

const theme = createSlice({
  name: sliceName,
  initialState: {
    type: window.matchMedia?.('(prefers-color-scheme: dark)').matches
      ? 'dark'
      : 'light',
  },
  reducers: {
    setType: (state, action) => {
      state.type = action.payload;
    },
  },
});

// ACTIONS
export const themeActions = {
  ...theme.actions,
};

export default theme;
